import cx from "classnames";

export const RoundTitle: React.FC<{
  title: string;
  date: string;
  className?: string;
}> = ({ title, date, className }) => (
  <div
    id="title"
    className={cx("flex flex-col  text-center items-center", className)}>
    <p className="subhead3">{title}</p>
    <span className="caption">{date}</span>
  </div>
);
